<div id="grid-wrapper" style="width: 100%; height: 100%">
  <ag-grid-angular
    [domLayout]="'normal'"
    [style.height]="errorCostRatesOverviewData.length > 20 ? '750px' : 'none'"
    [gridOptions]="gridOptions"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [pagination]="false"
    [multiSortKey]="multiSortKey"
    [getContextMenuItems]="getContextMenuItems"
    [enableBrowserTooltips]="true"
    [components]="frameworkComponents"
    [excelStyles]="excelStyles"
    (gridReady)="onGridReady($event)"
    (firstDataRendered)="onFirstDataRendered($event)"
    (gridSizeChanged)="onGridSizeChanged($event)"
    class="ag-theme-alpine_customize"></ag-grid-angular>
</div>

<pas-sidebar-holder [hasNavbar]="true">
  <div class="sidebar-contents">
    <ng-container>
      <div class="sidebar-element sidebar-row">
        <ul class="navbar-nav">
          @if (canUserCreateErrorCostRate()) {
            <li class="nav-item">
              <a (click)="onNewErrorCostRateBtn()" class="nav-link link-sidebar">
                <i class="material-icons">add_circle_outline</i>
                <span class="hidden-md-down" ui-test-id="createErrorCostRateBtn">
                  {{ 'AFTER_SALES_ERROR_COST_RATE_CREATE_NEW_BUTTON' | translate }}
                </span>
              </a>
            </li>
          }
          <li class="nav-item">
            <a (click)="onBtnCancel()" class="nav-link link-sidebar">
              <i class="material-icons">cancel</i>
              <span class="hidden-md-down" ui-test-id="cancelBtn">{{ 'CANCEL' | translate }}</span>
            </a>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</pas-sidebar-holder>

<ng-template #ErrorCostRateDialogTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="isAcceptanceAllowed()"
    (confirm)="onAcceptErrorCostRateDialog()"
    (cancel)="onCloseErrorCostRateDialog()"
    id="errorCostRateDialog"
    confirmationMessage=""
    modalTitle="{{ 'AFTER_SALES_ERROR_COST_RATE_DIALOG_TITLE' | translate }}"
    acceptButtonLbl="{{ 'SAVE' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}">
    <div [formGroup]="errorCostRateDialogForm">
      <div class="col-12">
        <div class="row">
          <pas-input
            [hasClearBtn]="false"
            [maxLength]="2"
            [formControl]="$any(errorCostRateDialogForm.get('errorCodeId'))"
            [validationMessages]="validationMessages"
            (keypress)="onlyNumbersAlowed($event)"
            class="col-2 pull-right"
            id="errorCostRateDialogErrorCode"
            subLabel="{{ 'AFTER_SALES_ERROR_COST_RATE_DIALOG_ERROR_CODE' | translate }}"></pas-input>
          <pas-input
            [maxLength]="250"
            [formControl]="$any(errorCostRateDialogForm.get('errorCodeDescription'))"
            [validationMessages]="validationMessages"
            class="col-4"
            id="errorCostRateDialogErrorCodeDescription"
            subLabel="{{ 'AFTER_SALES_ERROR_COST_RATE_DIALOG_ERROR_DESC' | translate }}"></pas-input>

          <pas-input
            [maxLength]="2"
            [formControl]="$any(errorCostRateDialogForm.get('errorCodeClass'))"
            [validationMessages]="validationMessages"
            (input)="forceUppercaseConditionally('errorCodeClass', $event)"
            class="col-3"
            id="errorCostRateDialogErrorCodeClass"
            subLabel="{{ 'AFTER_SALES_ERROR_COST_RATE_DIALOG_ERROR_CLASS' | translate }}"></pas-input>

          <pas-input-number
            [hasClearBtn]="false"
            [maxLength]="14"
            [decimalCount]="2"
            [decimalSeparator]="decimalSeparator"
            [formControl]="$any(errorCostRateDialogForm.get('costRate'))"
            [validationMessages]="validationMessages"
            class="col-3 pull-right"
            id="errorCostRateDialogCostRate"
            subLabel="{{ 'AFTER_SALES_ERROR_COST_RATE_DIALOG_COST_RATE_EUR' | translate }}"></pas-input-number>
        </div>
      </div>
      <div class="col-12">
        <div class="row" style="padding: 0px 315px">
          <div class="d-flex justify-content-center">
            @if (spinnerActive) {
              <pas-spinner [size]="'small'"></pas-spinner>
            }
          </div>
        </div>
      </div>
    </div>
  </tur-generic-modal-content>
</ng-template>
